import './modules/resize-end.js'
import './modules/viewport-units.js'
import './modules/dismissables.js'
import './modules/focus-visible-fallback.js'
import './modules/lazy-background.js'
import './modules/event-swiper.js'

import './alpine/init.js'

let init = () => {
  Alpine.start()
  document.body.classList.remove('not-initialized')
}

// Await the 'wpce:after-element-scripts' event to avoid starting Alpine before
// element-specific groundwork (e.g. element-specific Alpine plugins) is laid
document.addEventListener(
  'wpce:after-element-scripts',
  () => {
    // Initializing Alpine is quite a bit of CPU work.
    // If the browser supports it, we delay its initialization
    // until there are free CPU cycles, with a maximum of 3 seconds.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 3000 })
    } else {
      init()
    }
  },
  { once: true },
)
